
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround1On as ObiGround1OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-1-on.js';
 
 
 

 
 export const ObiGround1On = createComponent({
   react: React,
   tagName: 'obi-ground-1-on',
   elementClass: ObiGround1OnElement,
   events: {
     
   }
  });
 
 